import { BLOOM_ICONS, LEGACY_ICON_NAMES } from "./iconRegistry.js";

// ─── ICONS ───────────────────────────────────────────────
// The single icon component for the whole website (design-system/icons/registry.json): 24 px grid, 1.5 px line,
// round ends, drawn in the surrounding text colour. Replaces every emoji that used to stand in for an icon.
//   n         icon slug ("delete", "bag", "pin-to-top" ...) or an old Icon.jsx name (store, pkg, cog, cart, x ...)
//   size      px number, or a CSS length like "1.1em" so it scales with the text around it
//   filled    solid state for heart / star / bookmark / play / dot / alerts / show
//   inline    sits on the text baseline inside a line of text (used wherever an emoji used to be in a label)
export const Icon = ({ n, size = 18, color = "currentColor", filled = false, strokeWidth = 1.5, inline = false, style, title, ...rest }) => {
  const slug = BLOOM_ICONS[n] ? n : LEGACY_ICON_NAMES[n];
  const icon = BLOOM_ICONS[slug];
  if (!icon) return null;
  const solid = filled && icon.filled;
  const px = typeof size === "number" ? size : size;
  return (
    <svg width={px} height={px} viewBox="0 0 24 24" fill={solid ? color : "none"} stroke={color} strokeWidth={strokeWidth}
      strokeLinecap="round" strokeLinejoin="round" role={title ? "img" : undefined} aria-label={title} aria-hidden={title ? undefined : true} focusable="false"
      style={inline ? { display: "inline-block", verticalAlign: "-0.18em", flexShrink: 0, ...style } : style} {...rest}>
      <path d={icon.d} />
    </svg>
  );
};

// The old flower mark used to stand in for the 🌸 emoji as a decorative ornament in copy. It is retired — the site's
// brand is the "bloom" wordmark — so call sites keep compiling and simply render nothing.
export const BloomMark = () => null;

// The Bloom lockup: the clover mark plus the rounded "Bloom" wordmark. `light` = white mark + white text for the cobalt header.
export const Wordmark = ({ size = 30, light = false, style }) => (
  <span aria-label="Bloom" style={{ display: "inline-flex", alignItems: "center", gap: Math.round(size * 0.24), ...style }}>
    <img src="/bloom-mark-blue.png" alt="" width={Math.round(size * 0.9)} height={Math.round(size * 0.9)} style={{ display: "block", filter: light ? "brightness(0) invert(1)" : "none" }} />
    <span className="brandface" style={{ fontSize: Math.round(size * 0.95), lineHeight: 1, paddingTop: Math.max(1, Math.round(size * 0.07)), color: light ? "#fff" : "var(--ink)" }}>Bloom</span>
  </span>
);

// Initial-on-surface stand-in for a store without a photo (replaces the old clover placeholder).
export const Monogram = ({ name, size = 56, radius = 4, style }) => (
  <span aria-hidden="true" style={{ width: size, height: size, borderRadius: radius, background: "var(--surface)", color: "var(--ink)", border: "1px solid var(--border)", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: Math.round(size * 0.42), fontWeight: 700, flexShrink: 0, ...style }}>{(name || "?").trim().charAt(0).toUpperCase()}</span>
);
